module.exports = __webpack_public_path__ + "media/assets/images/smart_working/5-2-e672c38ec92ad9d1fea462e5f2b2779a.png";